export class User {
  id: number;
  username: string;
  email: string;
  user_type: string;
  friendship_kind?: string;
  is_active?: boolean;
  is_owner?: boolean;
  estado?: string;
  first_name?: string;
  last_name?: string;

  constructor(
    id: number,
    username: string,
    email: string,
    user_type: string,
    friendship_kind?: string,
    is_active?: boolean,
    is_owner?: boolean,
    estado?: string,
    first_name?: string,
    last_name?: string
  ) {
    this.id = id;
    this.username = username;
    this.email = email;
    this.user_type = user_type;
    this.friendship_kind = friendship_kind;
    this.is_active = is_active !== undefined ? is_active : true;
    this.is_owner = is_owner || false;
    this.estado = estado || 'activo';
    this.first_name = first_name || undefined;
    this.last_name = last_name || undefined;
  }

  get displayName(): string {
    if (this.first_name) {
      return this.last_name ? `${this.first_name} ${this.last_name}` : this.first_name;
    }
    return this.username;
  }
}